export var RESTORE = 'RESTORE';
export var SUCCESS_RESTORE = 'SUCCESS_RESTORE';
export var FAILURE_RESTORE = 'FAILURE_RESTORE';



// WEBPACK FOOTER //
// ./src/actions/auth/restore.js